import { ModulContainer } from 'components/Main/table/TableStyles';
import { usePortalContext } from 'context/PortalContext';
import React, { useEffect, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { useTheme } from 'styled-components';
import { HeadModul, IconButton, Modal, ModulHeader } from './DrawerModal Styled';
import { useSearchParams } from 'react-router-dom';
import Brief from './Main/Brief/Brief';
import Summary, { SubContainer, SummaryContainer } from './Main/Summary/Summary';
import { useCampaignContext } from 'context/CampaignContext';
import { VscEdit } from 'react-icons/vsc';
import { useClientCode, useTab } from 'customHooks/useParameters';
import PlanComponent from './Main/Plan/PlanContainer';
import { europinzedDate } from 'methods/dateMethods';
import { DarkButton } from 'components/style/Global';
import DeleteConfirmationModal from 'components/DeleteConfirmationModall';
import { deleteUmbrellaCampaign } from 'graphql/mutations';
import { DeleteUmbrellaCampaignMutationVariables, DeleteUmbrellaCampaignMutation } from 'API';
import { API } from 'aws-amplify';
import CustomReportTab from './CustomReports/CustomReportTab';
import { useLoggingActivity } from 'customHooks/useLogging';

type Props = {};

const DrawerModal = (props: Props) => {
  const { drawerIsOpen, setDrawerIsOpen, setEditCampaign } = usePortalContext();
  const { activeCampaign, fetchedPortalData } = useCampaignContext();
  const [getID, setID] = useClientCode();
  const logActivity = useLoggingActivity();

  // const links = ["brief", /* "plan", */ "summary"]

  const links = ['brief', 'plan', 'summary'];
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();
  const [tab] = useTab();
  const [approvedBudget, setApprovedBudget] = React.useState(null as null | number);
  const { budgeBrief } = usePortalContext();

  const ll = [
    {
      available: true,
      name: 'brief',
      title: 'Brief',
    },
    {
      available: activeCampaign?.authorized
        ? true
        : !activeCampaign?.authorized &&
            activeCampaign?.status !== 'CREATED' &&
            activeCampaign?.status !== 'NOT_BRIEFED'
          ? true
          : false,
      name: 'plan',
      title: 'Plan',
    },
    {
      available: activeCampaign?.authorized
        ? true
        : !activeCampaign?.authorized &&
            (activeCampaign?.status === 'CAMPAIGN_PUBLISHED' ||
              activeCampaign?.status === 'CAMPAIGN_PARTLY_PUBLISHED' ||
              Date.now() > new Date(activeCampaign?.endDate as string).getTime() ||
              (Date.now() > new Date(activeCampaign?.startDate as string).getTime() &&
                Date.now() < new Date(activeCampaign?.endDate as string).getTime()))
          ? true
          : false,
      name: 'summary',
      title: 'Summary',
    },
  ];

  const activeCampaignIsUmbrellaWithChild =
    activeCampaign?.campaignId.toString().startsWith('100') && activeCampaign?.childCampaigns?.length === 0
      ? true
      : false;

  const [deleteUmbrellaModal, setDeleteUmbrellaModal] = useState(false);

  const handleTabClick = async (tabName: string) => {
    // Log the tab click activity
    const actionMap: { [key: string]: string } = {
      brief: 'BRIEF_TAB',
      plan: 'PLAN_TAB',
      summary: 'SUMMARY_TAB',
    };

    logActivity({
      action: actionMap[tabName],
    }).catch(console.error);

    // Set the tab in search params
    searchParams.set('tab', tabName);
    setSearchParams(searchParams);
  };

  const deleteUmbrella = async (campaignID: number) => {
    try {
      const deletecampaign = (await API.graphql({
        query: deleteUmbrellaCampaign,
        variables: {
          ID: campaignID,
        } as DeleteUmbrellaCampaignMutationVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteUmbrellaCampaignMutation };
      console.log('deletecampaign', deletecampaign.data);
      if (deletecampaign.data.deleteUmbrellaCampaign) {
        setDrawerIsOpen(false);
        setDeleteUmbrellaModal(false);
        searchParams.delete('tab');
        searchParams.delete('campaignID');
        setSearchParams(searchParams);
        setID('none');
        setTimeout(() => {
          setID(getID);
        }, 1500);
      } else {
        alert('Error deleting campaign. Please try again.');
      }
    } catch (error) {
      console.error('Error deleting umbrella campaign:', error);
    }
  };

  const handleDeleteUmbrellaCampaign = (a: boolean) => {
    if (a) {
      deleteUmbrella(activeCampaign?.campaignId as number);
      setDeleteUmbrellaModal(false);
    } else {
      setDeleteUmbrellaModal(a);
    }
  };
  // console.log('tab', tab);
  return (
    <>
      {tab === 'customReport' ? (
        // <Modal>
        //   <HeadModul style={{ border: '100px solid red' }}>
        //     <div className="second">
        //       <button
        //         type="button"
        //         onClick={() => {
        //           setDrawerIsOpen(false);
        //           searchParams.delete('tab');
        //           searchParams.delete('campaignID');
        //           setSearchParams(searchParams);
        //         }}
        //       >
        //         <IoMdClose className="closeIcon" />
        //       </button>
        //     </div>
        //     <ModulContainer></ModulContainer>
        //   </HeadModul>
        // </Modal>
        <Modal>
          <CustomReportTab></CustomReportTab>
        </Modal>
      ) : (
        <Modal>
          <HeadModul>
            <ModulHeader>
              <div className="first">
                <div className="links">
                  {ll.map((link) => (
                    <IconButton
                      style={{
                        color: tab === link.name ? theme.brand : !link.available ? theme.border : '',
                        borderBottom: tab === link.name ? `1px solid ${theme.brand}` : '',
                        borderRadius: '0',
                      }}
                      key={link.name}
                      type="button"
                      disabled={!link.available}
                      onClick={() => handleTabClick(link.name)}
                    >
                      {link.name.charAt(0).toUpperCase() + link.name.slice(1)}
                    </IconButton>
                  ))}
                </div>
                <h1 style={{ display: 'flex', flexDirection: 'row' }}>
                  <div>
                    {' '}
                    {activeCampaign?.campaign}
                    <span className="campaignID">{`(${activeCampaign?.campaignId})`}</span>
                  </div>
                  <span style={{ alignSelf: 'self-end' }}>
                    <IconButton
                      /* className='someButton' */ style={{
                        fontSize: '12px',
                        marginLeft: '15px',
                        padding: '5px 6px 3px 6px',
                      }}
                      onClick={() => {
                        setDrawerIsOpen(false);
                        setEditCampaign(true) /* ; searchParams.delete("tab") */;
                        setSearchParams(searchParams);
                      }}
                    >
                      <VscEdit />
                      Edit
                    </IconButton>
                  </span>
                </h1>
              </div>

              <div className="second">
                <button
                  type="button"
                  className="secondClose"
                  onClick={() => {
                    setDrawerIsOpen(false);
                    searchParams.delete('tab');
                    searchParams.delete('campaignID');
                    setSearchParams(searchParams);
                  }}
                >
                  <IoMdClose className="closeIcon" />
                </button>

                {/*         <IconButton className='editCampaign' onClick={() => {
                            setDrawerIsOpen(false); setEditCampaign(true); searchParams.delete("tab"); setSearchParams(searchParams)
                        }}><VscEdit />Edit campaign</IconButton> */}
              </div>
              <div className="third">
                <h2>
                  Date: <span>{europinzedDate(activeCampaign?.startDate as string)}</span> -{' '}
                  <span>{europinzedDate(activeCampaign?.endDate as string)}</span>
                </h2>
                {/*           <div className='links'>
                            <IconButton>Comments</IconButton>
                            <IconButton>Additional Info 1</IconButton>
                            <IconButton>Additional Info 2</IconButton>
                        </div> */}

                {tab !== 'brief' && (
                  <div className="third">
                    <h2>
                      <span>
                        {
                          // budgeBrief === null ?

                          <>
                            {activeCampaign?.briefed_amount !== null && 'Briefed Amount:' + ' '}{' '}
                            <span>
                              <b>
                                {isNaN(Number(activeCampaign?.briefed_amount)) ||
                                Number(activeCampaign?.briefed_amount) === 0
                                  ? activeCampaign?.briefed_amount
                                  : Number(activeCampaign?.briefed_amount).toLocaleString()}
                              </b>
                            </span>{' '}
                            <span>
                              <b>{activeCampaign?.briefed_currency}</b>
                            </span>
                          </>
                          // : (
                          //   <>
                          //     {budgeBrief?.budget !== null && 'Briefed Amount:' + ' '}
                          //     <span>
                          //       <b>{budgeBrief?.budget}</b>
                          //     </span>{' '}
                          //     <span>
                          //       <b>{budgeBrief?.budget !== null && budgeBrief?.currency}</b>
                          //     </span>
                          //   </>
                          // )
                        }
                      </span>
                    </h2>
                  </div>
                )}
              </div>

              {/*    <div className='fourth'>
                        <h2>TAGS</h2>
                        <div className='tagsContainer'>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>
                            <Selections>Tag1</Selections>

                        </div>
                    </div> */}
            </ModulHeader>

            {activeCampaignIsUmbrellaWithChild ? (
              <ModulContainer>
                <h2 style={{ color: theme.primaryGray }}>This is an umbrella campaign with no child campaigns.</h2>
                <SummaryContainer>
                  <SubContainer>
                    <h1>What would you like to do with this campaign?</h1>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button
                        onClick={() => {
                          setDrawerIsOpen(false);
                          setEditCampaign(true) /* ; searchParams.delete("tab") */;
                          setSearchParams(searchParams);
                        }}
                      >
                        Edit - Add Child Campaigns
                      </button>
                      <DarkButton
                        onClick={() => {
                          setDeleteUmbrellaModal(true);
                        }}
                      >
                        Delete Campaign
                      </DarkButton>
                    </div>
                  </SubContainer>
                </SummaryContainer>
              </ModulContainer>
            ) : (
              <>
                {tab === 'brief' && (
                  <ModulContainer>
                    <Brief></Brief>
                  </ModulContainer>
                )}

                <ModulContainer>
                  <PlanComponent tab={tab} setApprovedBudget={setApprovedBudget} />
                </ModulContainer>

                {tab === 'summary' && (
                  <ModulContainer>
                    <Summary approvedBudget={approvedBudget}></Summary>
                  </ModulContainer>
                )}
                {}
              </>
            )}
          </HeadModul>
          {deleteUmbrellaModal && (
            <DeleteConfirmationModal
              handleDeleteConfirmationModal={handleDeleteUmbrellaCampaign}
              modalObject={{
                title: 'Delete Campaign',
                message: 'This will delete the umbrella campaign.',
                mainButton: 'Delete',
                secondaryButton: 'Cancel',
              }}
            ></DeleteConfirmationModal>
          )}
        </Modal>
      )}
    </>
  );
};

export default DrawerModal;
